import { Grid, Typography } from '@mui/material';

import {
  ILabelValueProp,
  LabelValueListVertical,
} from '@features/workspace/components/label-value-list';
import { employeePositionOptions } from '@features/workspace/views/company/utils/company-management';
import { useAppSelector } from '@store/hooks';
import { selectPrimaryUser } from '@features/workspace/store/selectors';

export function PrimaryUser() {
  const user = useAppSelector(selectPrimaryUser);

  if (!user) {
    return (
      <Typography className="labelHeader" variant="subtitle2">
        <i>No primary user defined!</i>
      </Typography>
    );
  }

  const propertiesLeft: Array<ILabelValueProp> = [
    {
      label: 'Name',
      value: `${user?.person?.firstName} ${user?.person?.lastName}` ?? '',
    },
    {
      label: 'Position',
      value:
        user?.assignment?.position !== undefined
          ? employeePositionOptions[user?.assignment?.position]?.label
          : 'Unknown',
    },
  ];

  const propertiesRight: Array<ILabelValueProp> = [
    { label: 'Contact number', value: user?.phoneNumber ?? '' },
    { label: 'Email Address', value: user?.email ?? '' },
  ];

  if (user?.isBlocked) {
    propertiesLeft.push({
      label: 'Blacklist',
      isWarning: true,
      value: user?.blockReason ?? '',
    });
  }

  return (
    <>
      <Grid container sx={{ width: '100%' }}>
        <Grid item xs={6}>
          <LabelValueListVertical properties={propertiesLeft} />
        </Grid>
        <Grid item xs={6}>
          <LabelValueListVertical properties={propertiesRight} />
        </Grid>
      </Grid>
    </>
  );
}
